//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
  },
  name: 'write',
  data() {
    return {}
  },
  methods: {
    getHandWrite(blob, base64) {
      console.log(blob);
      console.log(base64);
    }
  },
  watch: {
  },
  computed: {
  },
  created() {
  },
  mounted() {
  }
};
